<app-operaciones-usuarios [titulo]="titulo" [usuarios]="usuariosAEliminar" (funcion)="eliminarUsuarios($event)"
    botonPrimario="Eliminar" (refresh)="refresh()">
</app-operaciones-usuarios>